/* eslint-disable no-console */

import { register } from 'register-service-worker'

// 在 main.js 或 App.vue 的 mounted 階段執行
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.getRegistrations().then(function(registrations) {
//     for (let registration of registrations) {
//       // 找到舊的 Service Worker 並強制註銷
//       registration.unregister().then(function(boolean) {
//         if (boolean) {
//           alert('舊的 Service Worker 已成功註銷，將重新加載頁面');
//           // 可選擇是否強制重整頁面
//           // window.location.reload(true);
//         }
//       });
//     }
//   });

//   // 清除所有 Cache Storage (選擇性，若要更徹底)
//   // caches.keys().then(function(names) {
//   //   for (let name of names) {
//   //     caches.delete(name);
//   //   }
//   // });
// }


if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    // (1) Service Worker 首次成功註冊，且已經控制了客戶端頁面。
    // (2)新版本 Service Worker 已經轉為 active 狀態，且開始控制客戶端頁面。
    // Service Worker 已經接管控制權(以上兩種情況其中之一)。應用程式正從快取中提供服務。
    ready () {
      // alert(
      //   'App is being served from cache by a service worker.\n' +
      //   'For more details, visit https://goo.gl/AFskqB'
      // )
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },

    // Service Worker 檔案已成功被瀏覽器下載和註冊。
    registered () {
      // alert('Service worker has been registered.')
      console.log('Service worker has been registered.')
    },

    // 首次安裝成功後，所有預先快取 (pre-cached) 的內容已被成功地快取到瀏覽器中。
    cached () {
      // alert('Content has been cached for offline use.')
      console.log('Content has been cached for offline use.')
    },

    // 瀏覽器發現並開始下載一個新的 Service Worker 版本 (因為 service-worker.js 檔案內容有變動)。
    updatefound () {
      // alert('New content is downloading.')
      console.log('New content is downloading.')
    },

    // 新版本 Service Worker 已經下載、安裝完畢，處於 waiting 狀態，準備接管控制權(控制客戶端頁面)。
    updated () {
      // alert('New content is available; please refresh.')
      console.log('New content is available; please refresh.')
    },
    
    // 偵測到使用者目前沒有網際網路連線，應用程式正在離線模式下運行。
    offline () {
      // alert('No internet connection found. App is running in offline mode.')
      console.log('No internet connection found. App is running in offline mode.')
    },

    // 在註冊或更新 Service Worker 過程中發生錯誤。
    error (error) {
      // alert('Error during service worker registration:', error)
      console.log('Error during service worker registration:', error)
    }
  })
}
